import React from "react";

interface MashRankLogoProps {
  height?: number | string;
}

const MashRankLogo: React.FC<MashRankLogoProps> = ({ height = 65 }) => {
  return (
    <img
      src={require("../../assets/MashRankLogo.png")}
      alt="MashRank Logo"
      style={{
        height: typeof height === "number" ? `${height}px` : height,
        width: "auto",
        display: "block",
        objectFit: "contain",
      }}
    />
  );
};

export default MashRankLogo;
